var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 8,
    viewBox: "0 0 102 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.354 4.35356C101.549 4.1583 101.549 3.84172 101.354 3.64646L98.1716 0.464475C97.9763 0.269212 97.6597 0.269212 97.4645 0.464475C97.2692 0.659737 97.2692 0.976319 97.4645 1.17158L100.293 4.00001L97.4645 6.82844C97.2692 7.0237 97.2692 7.34028 97.4645 7.53554C97.6597 7.7308 97.9763 7.7308 98.1716 7.53554L101.354 4.35356ZM-4.37114e-08 4.5L101 4.50001L101 3.50001L4.37114e-08 3.5L-4.37114e-08 4.5Z",
    fill: "#B3B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.0abd76a847ed8814203b4f567d6e5519.svg";
export { ForwardRef as ReactComponent };